import { render, staticRenderFns } from "./ModalAddIngredient.vue?vue&type=template&id=fceb6c2c"
import script from "./ModalAddIngredient.vue?vue&type=script&lang=js"
export * from "./ModalAddIngredient.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports